
import React, { useEffect, useMemo, useState } from 'react';
import globalGetPadding from '../../utils/getPadding';
import { getFieldOptionsByCode } from '../../../../api/customForm';
import { getFontSize, getMerchantCode, getMerchantCode2, shallowEqualIgnoreOrder } from '../../utils/commonFun';
function getFontFamily(fontFamily) {
    switch (fontFamily) {
        case 'MODERN_SANS':
            return '"Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif';
        case 'BOOK_SANS':
            return 'Optima, Candara, "Noto Sans", source-sans-pro, sans-serif';
        case 'ORGANIC_SANS':
            return 'Seravek, "Gill Sans Nova", Ubuntu, Calibri, "DejaVu Sans", source-sans-pro, sans-serif';
        case 'GEOMETRIC_SANS':
            return 'Avenir, "Avenir Next LT Pro", Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif';
        case 'HEAVY_SANS':
            return 'Bahnschrift, "DIN Alternate", "Franklin Gothic Medium", "Nimbus Sans Narrow", sans-serif-condensed, sans-serif';
        case 'ROUNDED_SANS':
            return 'ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif';
        case 'MODERN_SERIF':
            return 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif';
        case 'BOOK_SERIF':
            return '"Iowan Old Style", "Palatino Linotype", "URW Palladio L", P052, serif';
        case 'MONOSPACE':
            return '"Nimbus Mono PS", "Courier New", "Cutive Mono", monospace';
        default:
            return undefined;
    }
}

const DisplayTextsPropsDefaults = {
    text: '',
};
function toCamel(str) {
    return str.replace(/([^_])(?:_+([^_]))/g, function ($0, $1, $2) {
        return $1 + $2.toUpperCase();
    });
}
export const FormDisplayTexts = (_a)=> {
    var _b, _c, _d, _e, _f, _g, _h, _i;
    var style = _a.style, props = _a.props, formClientWidth = _a.formClientWidth;
    const isMobile = formClientWidth <= 480;
    var wStyle = {
        backgroundColor: (_c = style === null || style === void 0 ? void 0 : style.backgroundColor) !== null && _c !== void 0 ? _c : undefined,
        fontSize: getFontSize(style?.fontSize, isMobile),
        fontFamily: getFontFamily(style === null || style === void 0 ? void 0 : style.fontFamily),
        fontWeight: (_e = style === null || style === void 0 ? void 0 : style.fontWeight) !== null && _e !== void 0 ? _e : undefined,
        textAlign: (_f = style === null || style === void 0 ? void 0 : style.textAlign) !== null && _f !== void 0 ? _f : undefined,
        padding: globalGetPadding(style === null || style === void 0 ? void 0 : style.padding, isMobile),
    };
    const textColor = (_b = style === null || style === void 0 ? void 0 : style.color) !== null && _b !== void 0 ? _b : undefined;
    var text = (_g = props === null || props === void 0 ? void 0 : props.text) !== null && _g !== void 0 ? _g : DisplayTextsPropsDefaults.text;
    var name = (_h = props === null || props === void 0 ? void 0 : props.name) !== null && _h !== void 0 ? _h : '';
    // if (props === null || props === void 0 ? void 0 : props.markdown) {
    //     return <EmailMarkdown style={wStyle} markdown={text}/>;
    // }
    const [fieldLoading, setFieldLoading] = useState(false);
    const [lastDependFields, setLastDependFields] = useState({});
    const [dependFields, setDependFields] = useState({});
    const [valueTexts, setValueTexts] = useState([]);
    
    const html = useMemo(()=>{
        const finalText = text?.replace(
            /\{\{\s*DisplayTexts\.(\w+)\s*\}\}/g,
            (match, key) => valueTexts?.[key] ? valueTexts?.[key] : match
        );
        return finalText?.replace(/<([a-zA-Z]+)([^>]*)style="([^"]*?)font-size:\s*(\d+)px([^"]*?)"(.*?)>/g, (match, tag, beforeStyle, styleStart, fontSize, styleEnd, afterStyle) => {
            const newStyle = `${styleStart}font-size: ${getFontSize(fontSize, isMobile)}px${styleEnd}`.trim();
            return `<${tag}${beforeStyle}style="${newStyle}" ${afterStyle}>`;
        });
    }, [text, valueTexts, isMobile]);

    useEffect(()=>{
        const fetchData = async () => {
            let res = [];
            if(_a?.fieldSource?.type === 'api' && _a?.fCode && _a?.cmCode && name) {
                //如果options是通过api获取，走这里。
                if(!fieldLoading) {
                    let dependValues = {};
                    let fullField = true;
                    if(_a?.fieldSource?.depends?.length) {
                        //需要获取其他字段的值来决定options，才发请求
                        _a?.fieldSource?.depends?.forEach(item=>{
                            if(!dependFields[item.fromField]) {
                                fullField = false;
                            }
                            else if((dependFields[item.fromField]?.isRequired && dependFields[item.fromField]?.value) || !dependFields[item.fromField]?.isRequired) {
                                dependValues[item.targetParam] = dependFields[item.fromField]?.value;
                            }
                            else {
                                fullField = false;
                            }
                        })
                    }
                    if(fullField) {
                        setFieldLoading(true);
                        const merchantCode = getMerchantCode(_a?.cmCode, 'form');
                        const getRes = await getFieldOptionsByCode({
                            "formCode": _a?.fCode,
                            "fieldCode": name,
                            "dependValues": dependValues
                        }, merchantCode || getMerchantCode2(_a?.cmCode), merchantCode ? null : 'form').catch(error => {
                            return null; // 必须 return，否则 getRes 是 undefined
                        });
                        setFieldLoading(false);
                        if(getRes?.options) {
                            const vals = getRes.options.filter(item=>!item.disabled);
                            res = vals?.reduce((acc, item) => {
                                const camelName = toCamel(item.label);
                                acc[camelName] = item.value ?? '';
                                return acc;
                            }, {});
                        }
                    }
                    
                }
            }
            else {
                
            }
            setValueTexts(res);
        };
        
        fetchData();
    }, [_a?.fieldSource?.type, _a?.fCode, _a?.cmCode,
        _a?.fieldSource?.type === 'api' ? (_a?.fieldSource?.depends?.length ? dependFields : null) : _a?.allFieldValues
    ])

    useEffect(()=>{
        //fieldSource: 通过api获取当前组件的数据，比如option
        if(_a?.fieldSource?.type === 'api' && _a?.fieldSource?.depends?.length) {
            let depend_fields = {};
            _a?.fieldSource?.depends?.forEach(item=>{
                depend_fields[item.fromField] = _a?.allFieldValues[item.fromField];
            })
            if (!shallowEqualIgnoreOrder(lastDependFields, depend_fields)) {
                setDependFields(depend_fields);
                setLastDependFields(depend_fields);
            }
        }
    }, [_a?.fieldSource, _a?.allFieldValues])

    return <div style={{
        ...wStyle,
        color: textColor
    }} dangerouslySetInnerHTML={{ __html: html }}>
        {/* {_a?.unSubData?.result === true ? (successText) : text} */}
    </div>;
}
